'use-client';
import PinItPinWidget from '../../PinItPinWidget';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(PinItPinWidget, {
  componentConsentPolicy: { advertising: true },
});
